import { useCredentialingTranslation } from '../../../../ui/hooks';
import { useFilterConfig } from '@juvare/common-data-table-ui/FiltersBar';
import { useMemo } from 'react';
export function useJasBoardHistoryFilterConfig() {
    const { t } = useCredentialingTranslation();
    const statusValues = useMemo(() => [
        { label: t('table.jasBoardStatusHistory.status.active'), value: 'active' },
        { label: t('table.jasBoardStatusHistory.status.inactive'), value: 'inactive' },
        { label: t('table.jasBoardStatusHistory.status.outOfDate'), value: 'outOfDate' },
        { label: t('table.jasBoardStatusHistory.status.failed'), value: 'failed' },
    ], [t]);
    const filterConfig = useFilterConfig((builder) => {
        const status = builder.quickFilterMultiSelect({
            dataPath: 'status',
            label: t('table.jasBoardStatusHistory.labels.status'),
            values: statusValues,
            widget: 'form.checkboxList',
        });
        const lastUpdated = builder.quickDateRangeFilter({
            dataPath: 'lastUpdatedAt',
            label: t('table.jasBoardStatusHistory.labels.lastUpdated'),
        });
        builder.allFiltersPanel({
            children: [status],
        });
        builder.allFiltersPanel({
            label: t('table.jasBoardStatusHistory.labels.lastUpdated'),
            children: [lastUpdated],
        });
        builder.allFiltersPanel({
            label: t('table.jasBoardStatusHistory.labels.lastChecked'),
            children: [
                builder.allFiltersWidget({
                    key: 'lastCheckedAt',
                    type: 'form.dateRangePicker',
                    label: t('table.jasBoardStatusHistory.labels.lastChecked'),
                }),
            ],
        });
        builder.allFiltersPanel({
            label: t('table.jasBoardStatusHistory.labels.lastSuccess'),
            children: [
                builder.allFiltersWidget({
                    key: 'lastSuccessAt',
                    type: 'form.dateRangePicker',
                    label: t('table.jasBoardStatusHistory.labels.lastSuccess'),
                }),
            ],
        });
    }, [statusValues, t]);
    return { filterConfig };
}
